import './homePage.scss';
import { HomePageController } from './HomePageController';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BaseNavbar from './../../layouts/BaseNavbar';
import VariablesEnum from '../../enums/VariablesEnum';

export interface HomePageProps { }
export interface HomePageState {
    workerResponse?: []
}

var defaultState: HomePageState = {
    workerResponse: []
}

var innerState: HomePageState = { ...defaultState }
var controller = new HomePageController()

const HomePage: React.FC<HomePageState> = (props: HomePageProps) => {
    let navigate = useNavigate();
    const getState = () => {
        return { ...innerState }
    }
    const setState = (partialState: any, overwrite?: boolean) => {
        if (overwrite) {
            innerState = { ...partialState }
        } else {
            innerState = { ...innerState, ...partialState }
        }
        setComponentState(innerState)
    }

    const [componentState, setComponentState] = useState<HomePageState>(innerState)

    controller.config(setState, getState, () => defaultState, props as any)
    console.log("componentState", componentState);

    useEffect(() => {
        controller.initialize()
    }, [])

    /* Redirection */

    function redirectToWorkerDetailsHandler(wID: number) {
        navigate(`/worker-details/${wID}/home`)
    }

    /* Page layout */

    const renderWorkerImgControls = () => {
        return (
            <>
                <BaseNavbar />
                <div className="home-section-grid">
                    <div className='home-page-grid'>
                        {
                            getState().workerResponse && getState().workerResponse!.length > 0 && getState().workerResponse!.map((itm: any, ind: number) => {
                                return (
                                    <div className='workers-list' key={itm.id} onClick={() => redirectToWorkerDetailsHandler(itm.id)}>
                                        <img className='home-all-workers-bg w-100 home-worker-desktop' src={VariablesEnum.BASE_URL + itm.workerUrl} alt="" />
                                        <img className='home-all-workers-bg w-100 tab-worker-desktop' src={VariablesEnum.BASE_URL + itm.workerBgUrl} alt="" />
                                        <img className='home-all-workers-bg w-100 mobile-worker-desktop' src={VariablesEnum.BASE_URL + itm.workerMobileBgUrl} alt="" />
                                        <h5 className='caption-title text-uppercase'>{itm.workerJobTitle}</h5>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </>
        )
    }

    return (<>{renderWorkerImgControls()} </>)
}


export default HomePage;